import React from "react";

const InfoCard = ({ title, data }) => {
  if (!data) {
    return (
      <div className="info-card">
        <h3 className="card-title">{title}</h3>
        <div className="card-content">
          <p>No data available</p>
        </div>
      </div>
    );
  }

  // Get data type from passed props to render correct data in the card
  const isBasicInfo = data.name !== undefined;
  const isPopularityInfo = data.star_ratings !== undefined;
  const isActivityInfo = data.updated_at !== undefined;

  //Helper functions
  const formatRepoSize = (repoSize) => {
    if (repoSize <= 1000) {
      return "Small (Quick to clone)";
    } else if (repoSize > 1000 && repoSize <= 50000) {
      return "Medium (Manageable sized repo)";
    } else {
      return "Large (Substantial codebase)";
    }
  };

  const formatCreatedDate = (createdDate) => {
    const date = new Date(createdDate);
    return date.toLocaleDateString();
  };

  const formatUpdatedDate = (updatedDate) => {
    const date = new Date(updatedDate);
    const currentDate = new Date();

    const daysDiff = Math.floor((currentDate - date) / (1000 * 60 * 60 * 24));

    if (daysDiff === 0) {
      return "Today";
    } else if (daysDiff === 1) {
      return "1 day ago";
    } else if (daysDiff < 30) {
      return `${daysDiff} ago`;
    } else {
      const months = Math.floor(daysDiff / 30);
      return `${months} month${months > 1 ? "s" : ""} ago`;
    }
  };

  const renderBasicInfo = () => {
    return (
      <div>
        <p>
          <strong>Name:</strong> {data.name}
        </p>
        <p>
          <strong>Description:</strong>{" "}
          {data.description !== null
            ? data.description
            : "No description available for this repo"}
        </p>
        <p>
          <strong>Language:</strong> {data.language}
        </p>
        <p>
          <strong>License:</strong>{" "}
          {data.license !== null
            ? data.license
            : "No license available for this repo"}
        </p>
        <p>
          <strong>Repo Size:</strong> {formatRepoSize(data.size)}
        </p>
        <p>
          <strong>Forked:</strong>{" "}
          {data.is_fork === false
            ? "N/A"
            : `This repo is forked from: ${data.parent}`}
        </p>
      </div>
    );
  };

  const renderPopularityInfo = () => {
    return (
      <div>
        <p>
          <strong>Stars:</strong> {data.star_ratings}
        </p>
        <p>
          <strong>Forks:</strong> {data.forks}
        </p>
        <p>
          <strong>Watchers:</strong> {data.watchers}
        </p>
      </div>
    );
  };

  const renderActivityInfo = () => {
    return (
      <div>
        <p>
          <strong>Created:</strong> {formatCreatedDate(data.created_at)}
        </p>
        <p>
          <strong>Last Updated:</strong> {formatUpdatedDate(data.updated_at)}
        </p>
        <p>
          <strong>Open Issues:</strong> {data.open_issues}
        </p>
      </div>
    );
  };

  return (
    <div className="info-card">
      <h3 className="card-title">{title}</h3>
      <div className="card-content">
        {isBasicInfo && renderBasicInfo()}
        {isPopularityInfo && renderPopularityInfo()}
        {isActivityInfo && renderActivityInfo()}
      </div>
    </div>
  );
};

export default InfoCard;
